// extracted by mini-css-extract-plugin
module.exports = {"search-input":"Search_search-input__36-NL"};